import { IAGAlertManagerDataRow } from "@pulse-ui/types/components/AGTable";
import { IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";
import { IAlertDestinations } from "../AlertManager.types";
import { parseDashedFieldNames } from "./transformers";

const PARAMETERS_KEYS_TO_EXCLUDE = [
  "name",
  "portfolio",
  "account",
  "alert_dest_list",
  "save_alert",
  "display_value",
  "config_name",
];

export const getPortfolioDisplayName = (
  portfolio_id: string,
  portfolios: IPortfolioMetadata[] | undefined
): string => {
  if (portfolios) {
    const portfolioMetadata = portfolios.find(
      (item) => item.portfolio_id === portfolio_id
    );
    return portfolioMetadata ? portfolioMetadata.display_name : portfolio_id;
  }
  return portfolio_id;
};

export const getParametersString = (
  value: any,
  portfolios?: IPortfolioMetadata[]
): string => {
  if (!value) return "";

  const parameters = Object.keys(value)
    .filter((key) => !PARAMETERS_KEYS_TO_EXCLUDE.includes(key))
    .map((key) => {
      if (key === "additional_portfolios" && Array.isArray(value[key])) {
        const portfolioNames = value[key].map((portfolioId: string) =>
          getPortfolioDisplayName(portfolioId, portfolios)
        );
        return `${parseDashedFieldNames(key)}: ${portfolioNames.join(", ")}`;
      }
      return `${parseDashedFieldNames(key)}: ${value[key]}`;
    });

  return parameters.join(" | ");
};

export const getAlertDestinationsString = (
  alert_destinations: IAlertDestinations[]
): string => {
  if (!alert_destinations || alert_destinations.length === 0) return "";

  return alert_destinations
    .map(
      (dest) =>
        `${dest.alert_dest_type}${dest.value ? `: ${dest.value}` : ""}`
    )
    .join(" | ");
};

export const mapChecksToRow = (
  data: any,
  portfolios?: IPortfolioMetadata[]
): IAGAlertManagerDataRow[] => {
  if (!data) return [];

  const rows: IAGAlertManagerDataRow[] = [];

  for (const key in data) {
    for (const value of data[key]) {
      const row: IAGAlertManagerDataRow = {
        row_id: `${value.name}-${value.portfolio || ""}-${value.account || ""}-key`,
        name: value.name,
        portfolio: value?.portfolio || null,
        account: value?.account || null,
        alert_type: key,
        alert_destinations: getAlertDestinationsString(
          value?.alert_dest_list || []
        ),
        parameters: getParametersString(value, portfolios),
        display_value: value?.display_value || null,
        original_row: { ...value },
      };
      rows.push(row);
    }
  }

  return rows;
};
